import { render, staticRenderFns } from "./accessspread.vue?vue&type=template&id=7f7d7749&scoped=true&"
import script from "./accessspread.vue?vue&type=script&lang=js&"
export * from "./accessspread.vue?vue&type=script&lang=js&"
import style0 from "./accessspread.vue?vue&type=style&index=0&id=7f7d7749&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7d7749",
  null
  
)

export default component.exports